import { useSelector, useDispatch } from 'react-redux'
import { featuresToggle } from 'connectors/feature-flags/feature-flags.state'
import { CollapseWrapper } from './dev-tools'

export function Features() {
  const features = useSelector((state) => state.features)
  const featureList = Object.keys(features)

  return featureList.length ? (
    <CollapseWrapper title='Features'>
      {featureList.map((feature) => (
        <FeatureToggle feature={feature} key={feature} />
      ))}
    </CollapseWrapper>
  ) : null
}

function FeatureToggle({ feature }) {
  const dispatch = useDispatch()
  const featureState = useSelector((state) => state.features[feature])
  const handleChange = () => dispatch(featuresToggle(feature))

  return (
    <div>
      <input
        type="checkbox"
        id={feature}
        checked={featureState}
        onChange={handleChange}
      />
      <label htmlFor={feature}>{feature}</label>
    </div>
  )
}
